import { destroy, SubmissionError } from 'redux-form';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import forEach from 'lodash/forEach';

const defaultInitialState = {
	isStatusChangeFormShowed: false
};

const createForm = () => {
	const namespace = 'conversions';

	const TOGGLE_FORM = `${namespace}-toggle-status-change-form`;

	const SUBMIT_FORM_OK = `${namespace}-submit-status-change-form-ok`;
	const SUBMIT_FORM_FAIL = `${namespace}-submit-status-change-form-fail`;

	const initialState = { ...defaultInitialState };

	const actions = {
		toggleStatusChangeForm: () => dispatch => {
			dispatch({ type: TOGGLE_FORM  });
		},
		submitConversionsStatusChange: (formData) => (dispatch, getState) => {
			const data = {
				...formData,
				ids: formData.ids && formData.ids.split(',').map(val => parseInt(val)),
				status: formData.status && formData.status[0].value,
				cancellation_reason: formData.cancellation_reason && formData.cancellation_reason[0].value
			};
			if (!data.ids || !data.ids.length) {
				throw new SubmissionError({ ids: 'Empty or invalid ids' });
			}

			return http({
				url: endpoints.CONVERSIONS.STATUS,
				method: 'put',
				data: data,
				actions: [ SUBMIT_FORM_OK, SUBMIT_FORM_FAIL ]
			})(dispatch).then(action => {
				if (action.type === SUBMIT_FORM_OK) {
					dispatch(destroy('conversionsStatusChangeForm'));
				}
				if (action.type === SUBMIT_FORM_FAIL && action.payload.response.status === 400) {
					const validationsErrors = {};
					const responseErrors = action.payload.response.data;

					forEach(responseErrors, value => {
						const key = value.dataPath.slice(1);
						validationsErrors[key] = value.message;
					});

					throw new SubmissionError(validationsErrors);
				}
			});
		}
	};

	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state, isStatusChangeFormShowed: !state.isStatusChangeFormShowed
		})
	};

	const selectors = {
		getIsStatusChangeFormShowed: state => state.conversions.isStatusChangeFormShowed,
		getConversionStatusOptions:
				state => state.root.lists['conversion-statuses'].filter(item => item.id !== 'approved'),
		getConversionCancellationReasons: state => state.root.lists['conversion-cancellation-reasons']
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/change-status-form/index.js